// extracted by mini-css-extract-plugin
export var bodySections = "_db-8";
export var gray = "_db-7";
export var green = "_db-4";
export var iconContainer = "_db-9";
export var iconWidgetContainer = "_db-1";
export var phoneIcon = "_db-2";
export var red = "_db-5";
export var statusDot = "_db-3";
export var widgetContainer = "_db-0";
export var yellow = "_db-6";